var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-2 error--text",attrs:{"text":""},on:{"click":function($event){return _vm.unlink(_vm.placeId)}}},[_vm._v("Desvicunlar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }